import DetailPoints from "../DetailPoints";
import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCarmfAsv = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>        {context.state['Carriere'+ClientConjoint].filter((Carriere) => Carriere.Nature === "Carmf" && Carriere.ParamCotisations.ConventionneCarmf !== "non" )
                    .length > 0 && (
        <div className="card">
          <div className="category-column">
            <label className="prise-en-charge-cell-label" style={{ marginBottom: 0 }}>
              ASV CARMF
            </label>
          </div>
          <div className="value-column">
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteSuppCarmf}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"RetraiteSuppCarmf",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCarmfSupp}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCarmfSupp",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={resultRetraite?.InfosRetraite?.Carmf?.General?.AsvPointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Carmf?.General?.AsvPointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
            <DetailPoints caisse="Carmf" regime="Asv" champ="AsvPointCalcule" libelle="CARMF ASV" />
          </div>
        </div>
      )}
    </>
  );
};
export default PointCarmfAsv;
